import React from "react";
import { Link } from "react-router-dom";
import styles from "./style.module.css";

import { ReactComponent as FooterLogo } from "../../assets/Home/footer-logo.svg";

// Socials
import { ReactComponent as Instagram } from "../../assets/Home/instagram.svg";
import { ReactComponent as Facebook } from "../../assets/Home/facebook.svg";
import { ReactComponent as X } from "../../assets/Home/x.svg";
import { ReactComponent as Norlics } from "../../assets/Home/Norlics.svg";

const Footer = () => {
	return (
		<>
			<div id={`bsr-page-footer`}>
				<div
					className={` ${styles.footer__home} row bsr-footer-main-links`}
				>
					<div className="col-sm-6 col-md-3 col-lg-4 bsr-footer-links">
						{/* <h5>Heading</h5> */}
						<FooterLogo />
						<ul className="list-group">
							{/* <li className={`${styles.footer__item} list-group-item`}><Link to="#"><FooterLogo /></Link></li> */}
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="#">
									Revenue Centre, State Secretariat Complex,
									Okpara Avenue, Opposite State CID Enugu,
									Enugu State, Nigeria.
								</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<a
									href="mailto: care@enugurevenueservice.gov.ng"
									style={{
										color: "rgba(0, 92, 184, 1)"
									}}
								>
									esirs@enugustate.gov.ng
								</a>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<a href="tel:08075625555">08075625555</a>
							</li>
						</ul>
					</div>

					<div className="col-sm-2 bsr-footer-links">
						<h5>QUICK LINKS</h5>
						<ul className="list-group">
							{/* <li className={`${styles.footer__item} list-group-item`}><Link to="#">Get ESBN</Link></li> */}
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="/login">Login to Enugu CMS</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="#">Retrieve ESBN</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="/reset-password">
									Self Service - Forgot password
								</Link>
							</li>
						</ul>
					</div>

					<div className="col-sm-6 col-md-2 bsr-footer-links">
						<h5>MORE</h5>
						<ul className="list-group">
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="#">About Us</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
								type="button"
								data-toggle="modal"
								data-target="#lookUpESBN"
							>
								<Link to="#">ESBN Self Service</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="#">News</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="#">Visit our FAQ</Link>
							</li>
						</ul>
					</div>
					<div className="col-sm-2 bsr-footer-links">
						<h5>PAY TAX WITH</h5>
						<ul className="list-group">
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="/interswitchpage">Interswitch</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="/remitapage">Remita</Link>
							</li>
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="/flutterwavepage">Flutterwave</Link>
							</li>
						</ul>
					</div>
					<div className="col-sm-6 col-md-2 bsr-footer-links">
						<h5>FOLLOW US ON</h5>
						<ul className="list-group">
							<li
								className={`${styles.footer__item} list-group-item`}
							>
								<Link to="#">
									<Instagram />
									<X />
									<Facebook />
								</Link>
							</li>
						</ul>
					</div>
				</div>
				<hr style={{ width: "91%" }} />
			</div>
			<div className={styles.credits}>
				<p className="col-6">
					Copyright {new Date().getFullYear()} ESIRS. All rights
					reserved
				</p>
				<p className="col-6">
					Powered by <Norlics />
				</p>
			</div>
		</>
	);
};

export default Footer;
